import { atom, useAtom } from "jotai";

export const showBridgeHistoryAtom = atom<boolean>(false);

export const useShowBridgeHistory = () => {
  const [showBridgeHistory, setShowBridgeHistory] = useAtom(
    showBridgeHistoryAtom,
  );

  return {
    showBridgeHistory,
    setShowBridgeHistory,
  };
};
